import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode | ((sidebarOpen: boolean) => React.ReactNode);
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
          <Header />
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} onToggle={handleToggleSidebar} />
       <Box
  component="main"
  sx={{
    flexGrow: 1,
    pt: '64px',
    pb: '32px',
    px: 0,
    backgroundColor: '#f5f5f5',
    height: '100%',
    overflow: 'hidden',
    transition: 'all 0.2s ease-in-out',
  }}
>
  {typeof children === 'function' ? children(sidebarOpen) : children}
</Box>

      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
